import React, { useState, useEffect } from 'react';
import { post, get, put } from '../../utils/fetchAPI';

const AddLocations = ({ modalTitle, onClose, onAddLocation, onAddLocationSuccess, initialData, organizationId }) => {
  const initialformData = {
    organization: organizationId,
    name:'',
    alias: '',
    description: '',
    contact: [
      { purpose: '', name: '', contact: [{ system: 'mobile', value: '' }] }
    ],
    address: {
      use: 'work',
      text: '',
      lineOne: '',
      lineTwo: '',
      city: '',
      district: '',
      state: '',
      postalCode: '',
      country: 'Bangladesh',
    },
    // hoursOfOperation: {
    //   availableTime: [
    //     {
    //       daysOfWeek: "",
    //       allDay: false,
    //       visitHours: [
    //           {
    //               availableStartTime: "",
    //               availableEndTime: ""
    //           }
    //       ]
    //     }
    //   ]
    // },
    status: 'active'
  }
  const [organizations, setOrganizations] = useState([]);
  const [formData, setFormData] = useState(
    initialData || initialformData

  );

  useEffect(() => {
    if (initialData){
      if(initialData?.contact?.length === 0){
        let prevContact = [...initialData?.contact,{ purpose: '', name: '', contact: [{ system: '', value: '' }] }];
        setFormData({...initialData, contact:prevContact});
    
      }
      else{
        setFormData(initialData);
      }
      
    }
    else{
      setFormData(initialformData);
    }
}, [initialData]);

  //organization list fetching
  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const response = await get('organization/list');
        console.log("org array", response);
        if (response.status === 200) {
          setOrganizations(response.data);
        }
      } catch (error) {
        console.error('Error fetching organizations:', error);
      }
    };
    fetchOrganizations();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Handling change for ${name}: ${value}`);
    if (name === 'organization') {
      // Access the array of organizations correctly
      const orgArray = organizations?.organizations || [];
      // Find the selected organization by ID
      const selectedOrganization = orgArray.find(org => org._id === value);
      const organizationName = selectedOrganization ? selectedOrganization.name : '';

      setFormData((prevState) => ({
          ...prevState,
          organization: value,
          name: organizationName, // Set the name field with the organization's name
      }));
  } else if (name.startsWith('address.')) {
      const field = name.split('.')[1];
      setFormData((prevState) => ({
        ...prevState,
        address: {
          ...prevState.address,
          [field]: value,
        },
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  // Handle contact details (purpose and name)
  const handleContactChange = (contactIndex, field, value) => {
    const updatedContacts = [...formData.contact];
    updatedContacts[contactIndex][field] = value;
    setFormData({ ...formData, contact: updatedContacts });
    };

    // Handle individual contact system and value
    const handleContactDetailChange = (contactIndex, detailIndex, field, value) => {
        const updatedContacts = [...formData.contact];
        updatedContacts[contactIndex].contact[detailIndex][field] = value;
        setFormData({ ...formData, contact: updatedContacts });
    };

    // Add a new contact section
    const addContact = () => {
        setFormData((prevData) => ({
            ...prevData,
            contact: [...prevData.contact, { purpose: '', name: '', contact: [{ system: '', value: '' }] }]
        }));
    };
    console.log("jjha", formData);

    // Remove a contact section
    const removeContact = (contactIndex) => {
        const updatedContacts = formData.contact.filter((_, i) => i !== contactIndex);
        setFormData({ ...formData, contact: updatedContacts });
    };

    // Add a new contact detail to a specific contact
    const addContactDetail = (contactIndex) => {
        const updatedContacts = [...formData.contact];
        updatedContacts[contactIndex].contact.push({ system: '', value: '' });
        setFormData({ ...formData, contact: updatedContacts });
    };

    // Remove a specific contact detail
    const removeContactDetail = (contactIndex, detailIndex) => {
        const updatedContacts = [...formData.contact];
        updatedContacts[contactIndex].contact = updatedContacts[contactIndex].contact.filter((_, i) => i !== detailIndex);
        setFormData({ ...formData, contact: updatedContacts });
    };

    //handle hours of operation
    // const handleHoursChange = (index, field, value,e) => {
    //   const updatedHours = [...formData.hoursOfOperation.availableTime];
    //   updatedHours[index][field] = value;
    //   setFormData((prevState) => ({
    //     ...prevState,
    //     hoursOfOperation: { availableTime: updatedHours }
    //   }));
    // };
    
    //handle visit hour change
    // const handleVisitHourChange = (index, visitIndex, field, value) => {
    //   const updatedHours = [...formData.hoursOfOperation.availableTime];
    //   updatedHours[index].visitHours[visitIndex][field] = value;
    //   setFormData((prevState) => ({
    //     ...prevState,
    //     hoursOfOperation: { availableTime: updatedHours }
    //   }));
    // };
    
    // Add a new availableTime section
    // const addAvailableTime = () => {
    //   setFormData((prevData) => {
    //     // null checking if no data in hours of operation
    //     const currentHours = prevData.hoursOfOperation?.availableTime || [];
    //
    //     return {
    //       ...prevData,
    //       hoursOfOperation: {
    //         availableTime: [
    //           ...currentHours,
    //           {
    //             daysOfWeek: "Sunday",
    //             allDay: false,
    //             visitHours: [{ availableStartTime: "", availableEndTime: "" }]
    //           }
    //         ]
    //       }
    //     };
    //   });
    // };

    // Add a new visit hour to a specific availableTime section
    // const addVisitHour = (index) => {
    //   const updatedHours = [...formData.hoursOfOperation.availableTime];
    //   updatedHours[index].visitHours.push({ availableStartTime: "", availableEndTime: "" });
    //   setFormData((prevState) => ({
    //     ...prevState,
    //     hoursOfOperation: { availableTime: updatedHours }
    //   }));
    // };

    // const validateHours = () => {
    //     for (const hour of formData.hoursOfOperation.availableTime) {
    //         if (!hour.allDay) {
    //             for (const visit of hour.visitHours) {
    //                 if (!visit.availableStartTime || !visit.availableEndTime) {
    //                     return false; // validation fail
    //                 }
    //             }
    //         }
    //     }
    //     return true;
    // };


    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Form Data before submission:", formData);

        // if (!validateHours()) {
        //     alert("Please fill all required visit hours");
        //     return;
        // }

        const updatedFormData = {
            ...formData,
            organization: organizationId, // fixed orgId
        };

        try {
            if (initialData) {
                // update
                const response = await put(`organization/location/update/${formData?._id}`, updatedFormData);
                if (response.status === 200) {
                    onAddLocation();
                    onAddLocationSuccess();
                    onClose();
                    setFormData(initialformData);
                }
            } else {
                // create
                const response = await post("organization/location/create", updatedFormData);
                console.log("location add form data: ", response);

                if (response.status === 201) {
                    onAddLocation();
                    onAddLocationSuccess();
                    onClose();
                    setFormData(initialformData);
                    console.log("Location added successfully:", response.data);
                }
            }
        } catch (error) {
            console.error("Error adding location:", error);
        }
    };



    return (
    <div className="p-8">
      <h2 className="text-2xl font-bold text-blue-500 mb-6">{modalTitle}</h2>
      <form onSubmit={handleSubmit} className="text-black flex flex-col w-full ">
        <div className="flex flex-wrap max-h-[30rem] overflow-y-auto">
            {/* Left Column */}
            <div className="w-full md:w-1/2 pr-4 space-y-6">
                <div className="flex flex-col">
                    <label className="mb-1 text-left">Name: <span className="text-red-500">*</span></label>
                    <input
                        type="text"
                        name="name"
                        value={formData?.name}
                        onChange={handleChange}
                        required
                        className="border border-gray-300 rounded-lg px-4 py-2"
                    />
                </div>

                {/* Alias */}
                <div className="flex flex-col">
                    <label className="mb-1 text-left">Alias:</label>
                    <input
                        type="text"
                        name="alias"
                        value={formData?.alias}
                        onChange={handleChange}
                        className="border border-gray-300 rounded-lg px-4 py-2"
                    />
                </div>

                {/* Description */}
                <div className="flex flex-col">
                    <label className="mb-1 text-left">Description:</label>
                    <textarea
                        name="description"
                        value={formData?.description}
                        onChange={handleChange}
                        className="border border-gray-300 rounded-lg px-4 py-2"
                    />
                </div>
            </div>

            {/* Right Column */}
            <div className="w-full md:w-1/2 pl-4 space-y-6">
                <div className="space-y-4">
                    <label className="mb-1 text-left">Address: <span className="text-red-500">*</span></label>

                    {/* Full Address */}
                    <input
                        type="text"
                        name="address.text"
                        value={formData?.address?.text}
                        onChange={handleChange}
                        placeholder="Full Address"
                        required
                        className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                    />

                    {/* Line One and Line Two */}
                    <div className="flex space-x-4">
                        <input
                            type="text"
                            name="address.lineOne"
                            value={formData?.address?.lineOne}
                            onChange={handleChange}
                            placeholder="Line One"
                            hidden
                            className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                        />
                        <input
                            type="text"
                            name="address.lineTwo"
                            value={formData?.address?.lineTwo}
                            onChange={handleChange}
                            placeholder="Line Two"
                            hidden
                            className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                        />
                    </div>

                    {/* City and District */}
                    <div className="flex space-x-4">
                        <input
                            type="text"
                            name="address.city"
                            value={formData?.address?.city}
                            onChange={handleChange}
                            placeholder="City"
                            hidden
                            className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                        />
                        <input
                            type="text"
                            name="address.district"
                            value={formData?.address?.district}
                            onChange={handleChange}
                            placeholder="District"
                            hidden
                            className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                        />
                    </div>

                    {/* State and Postal Code */}
                    <div className="flex space-x-4">
                        <input
                            type="text"
                            name="address.state"
                            value={formData?.address?.state}
                            onChange={handleChange}
                            placeholder="State"
                            hidden
                            className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                        />
                        <input
                            type="text"
                            name="address.postalCode"
                            value={formData?.address?.postalCode}
                            onChange={handleChange}
                            placeholder="Postal Code"
                            hidden
                            className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                        />
                    </div>
                </div>
                {/* Hours of Operation Section */}
                {/*<div className="mt-4">*/}
                {/*  <label className="text-lg font-semibold">Hours of Operation:</label>*/}
                {/*  {formData?.hoursOfOperation?.availableTime?.map((hour, index) => (*/}
                {/*    <div key={index} className="border p-4 rounded-lg mt-2">*/}
                {/*      <div className="flex items-center gap-4">*/}
                {/*        <span className="font-semibold">Day:</span>*/}
                {/*        <select*/}
                {/*          value={hour.daysOfWeek}*/}
                {/*          onChange={(e) => handleHoursChange(index, 'daysOfWeek', e.target.value)}*/}
                {/*          className="border px-2 py-1 rounded-lg"*/}
                {/*        >*/}
                {/*          <option value="Sunday">Sunday</option>*/}
                {/*          <option value="Monday">Monday</option>*/}
                {/*          <option value="Tuesday">Tuesday</option>*/}
                {/*          <option value="Wednesday">Wednesday</option>*/}
                {/*          <option value="Thursday">Thursday</option>*/}
                {/*          <option value="Friday">Friday</option>*/}
                {/*          <option value="Saturday">Saturday</option>*/}
                {/*        </select>*/}

                {/*        <label className="ml-4 flex items-center">*/}
                {/*          <input*/}
                {/*            type="checkbox"*/}
                {/*            checked={hour.allDay}*/}
                {/*            onChange={(e) => handleHoursChange(index, 'allDay', e.target.checked)}*/}
                {/*            className="mr-2"*/}
                {/*          />*/}
                {/*          Open All Day*/}
                {/*        </label>*/}
                {/*      </div>*/}

                {/*      {!hour.allDay && (*/}
                {/*        <div className="mt-2">*/}
                {/*          {hour.visitHours.map((visit, visitIndex) => (*/}
                {/*            <div key={visitIndex} className="flex gap-4 mt-2">*/}
                {/*              <input*/}
                {/*                type="time"*/}
                {/*                value={visit.availableStartTime}*/}
                {/*                onChange={(e) => handleVisitHourChange(index, visitIndex, 'availableStartTime', e.target.value)}*/}
                {/*                className="border rounded-lg px-2 py-1"*/}
                {/*              />*/}
                {/*              <span>-</span>*/}
                {/*              <input*/}
                {/*                type="time"*/}
                {/*                value={visit.availableEndTime}*/}
                {/*                onChange={(e) => handleVisitHourChange(index, visitIndex, 'availableEndTime', e.target.value)}*/}
                {/*                className="border rounded-lg px-2 py-1"*/}
                {/*              />*/}
                {/*            </div>*/}
                {/*          ))}*/}
                {/*          <button*/}
                {/*            type="button"*/}
                {/*            onClick={() => addVisitHour(index)}*/}
                {/*            className="text-secondary px-3 py-2 rounded-md mt-2"*/}
                {/*          >*/}
                {/*            + Add Visit Hour*/}
                {/*          </button>*/}
                {/*        </div>*/}
                {/*      )}*/}
                {/*    </div>*/}
                {/*  ))}*/}
                {/*  <button type="button" onClick={addAvailableTime} className="text-white bg-primary px-3 py-2 rounded-md mt-3">*/}
                {/*        + Add New Hours of Operations*/}
                {/*    </button>*/}
                {/*</div>*/}

                {/* Organization Dropdown */}
                <div className="flex flex-col hidden">
                    <label className="mb-1 text-left">Organization:</label>
                    <select
                        name="organization"
                        value={formData?.organization}
                        onChange={(e) =>
                          setFormData((prevState) => ({
                            ...prevState,
                            organization: e.target.value,
                          }))
                        }
                        required
                        className="border border-gray-300 rounded-lg px-4 py-2"
                    >
                        {/* <option value="">Select an organization</option> */}
                        {/* {console.log("on dropdown", organizations._id)}
                        {Array.isArray(organizations?.organizations) &&
                        organizations.organizations.map((org) => ( */}
                            <option key={organizationId} value={organizationId}>
                                {organizationId}
                            </option>
                        {/* ))} */}
                    </select>
                </div>
                {/* Contact Section */}
                <div className="mt-4">
                    <label className="flex py-2 text-lg">Contacts: <span className="text-red-500">*</span></label>
                    {formData?.contact?.map((contact, contactIndex) => (
                        <div key={contactIndex} className="border p-3 mt-3 rounded">
                            <div className="flex gap-5 mb-2">
                                <input
                                    type="text"
                                    placeholder="Purpose"
                                    value={contact?.purpose}
                                    onChange={(e) => handleContactChange(contactIndex, 'purpose', e.target.value)}
                                    className="text-sm border p-2 rounded-md w-full"
                                    required
                                />
                                <input
                                    type="text"
                                    placeholder="Contact Name"
                                    value={contact?.name}
                                    onChange={(e) => handleContactChange(contactIndex, 'name', e.target.value)}
                                    className="text-sm border p-2 rounded-md w-full"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => removeContact(contactIndex)}
                                    className="bg-red-500 text-sm text-white px-2 rounded w-[20rem]"
                                >
                                    Remove Contact
                                </button>
                            </div>
                            {contact?.contact?.map((detail, detailIndex) => (
                                <div key={detailIndex} className="flex gap-5 mb-2">
                                    <select
                                        value={detail?.system}
                                        onChange={(e) =>
                                            handleContactDetailChange(contactIndex, detailIndex, 'system', e.target.value)
                                        }
                                        className="text-sm border p-2 rounded-md w-full"
                                        required>
                                        <option value="" disabled>Select System</option>
                                        <option value="mobile">mobile</option>
                                        <option value="fax">fax</option>
                                        <option value="email">email</option>
                                    </select>
                                    <input
                                        type="text"
                                        placeholder="Value"
                                        value={detail?.value}
                                        onChange={(e) =>
                                            handleContactDetailChange(contactIndex, detailIndex, 'value', e.target.value)
                                        }
                                        className="text-sm border p-2 rounded-md w-full"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => removeContactDetail(contactIndex, detailIndex)}
                                        className="bg-red-500 text-white px-2 rounded text-sm w-[20rem]"
                                    >
                                        Remove Detail
                                    </button>
                                </div>
                            ))}
                            <button
                                type="button"
                                onClick={() => addContactDetail(contactIndex)}
                                className="text-secondary px-3 py-2 rounded-md mt-2"
                            >
                                + Add Contact Detail
                            </button>
                        </div>
                    ))}
                    <button type="button" onClick={addContact} className="text-white bg-primary px-3 py-2 rounded-md mt-3">
                        + Add New Contact
                    </button>
                </div>
            </div>
        </div>
        {/* Submit Button */}
        <div className="flex gap-5 mt-6">
            <button
                type="submit"
                className="text-sm px-4 py-2 bg-primary text-white rounded-md"
            >
                {initialData ? 'Update Location' : 'Add Location'}
            </button>
            <button type="button" onClick={onClose} className="text-sm px-4 py-2 bg-secondary text-white rounded-md">Cancel</button>
        </div>
    </form>

        

    </div>
  );
};

export default AddLocations;
